import type { ScopeUsageResponse } from '@ydistri/api-sdk';
import { ReadOnlyItem } from '@ydistri/ds';
import { computeRemSize } from '@ydistri/theme';
import { Space, Spin, Typography } from 'antd';
import React from 'react';
import { styled } from 'styled-components';
import { formatScopeUsage } from '../../../components/domain/Scopes/scopeUsageFormatting';

const LABEL_WIDTH = '12rem';

const ScopeUsageList = styled.ul`
  margin: 0;
  padding-left: ${computeRemSize(20)};
`;

interface ScopeUsageSummaryProps {
  isError: boolean;
  isFetching: boolean;
  isLoading: boolean;
  usages: ScopeUsageResponse[];
}

const ScopeUsageSummary: React.FC<ScopeUsageSummaryProps> = ({
  isError,
  isFetching,
  isLoading,
  usages,
}) => {
  const hasUsages = usages.length > 0;

  return (
    <ReadOnlyItem alignItems="flex-start" label="Used in" labelWidth={LABEL_WIDTH}>
      <Space direction="vertical" size="small">
        {hasUsages && (
          <ScopeUsageList aria-label="Scope usages">
            {usages.map(usage => (
              <li key={`${String(usage.type)}-${usage.occurrenceId}`}>{formatScopeUsage(usage)}</li>
            ))}
          </ScopeUsageList>
        )}
        {isFetching && (
          <Space size="small">
            <Spin size="small" />
            <Typography.Text type="secondary">
              {isLoading ? 'Loading Scope usages…' : 'Refreshing Scope usages…'}
            </Typography.Text>
          </Space>
        )}
        {!hasUsages && !isFetching && !isError && <Typography.Text>Not used</Typography.Text>}
        {isError && (
          <Typography.Text type="warning">
            {hasUsages
              ? 'Scope usages could not be refreshed.'
              : 'Scope usages could not be loaded.'}
          </Typography.Text>
        )}
      </Space>
    </ReadOnlyItem>
  );
};

export default ScopeUsageSummary;
